const handleLocationClick = (lat, lng) => {
    // Construct Google Maps URL with latitude and longitude
    const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
    // Open Google Maps in a new tab
    window.open(googleMapsUrl, '_blank');
};

export default handleLocationClick